import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";
import KeyMajorMinorButton from "../music_controls/custom_buttons/KeyMajorMinorButton";

interface Props {}
interface State {}

const TITLE = "Major or Minor key?";
const shortNames = [false, true];
const descriptions = ["", ""];

function printShortName(x: boolean): string {
  switch (x) {
    case true:
      return "Major";
    case false:
      return "Minor";
  }
}

export default class KeyMajorMinorToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = () => {
    const keySelectionOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...keySelectionOptions, isPreferMajor: !keySelectionOptions.isPreferMajor },
    });
  };

  render(): ReactNode {
    const setting = this.context.keySelectionOptions.isPreferMajor;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={setting}
        printShortName={printShortName}
        onChange={this.changeSetting}
        extraInfo={
          <p>
            Shortcut: hold shift and press M, or press the <KeyMajorMinorButton /> button.
          </p>
        }
      />
    );
  }
}

KeyMajorMinorToggle.contextType = AppContextType;
